const IntervalPlayingMode = Object.freeze({
    SIMULTANEOUS: 'SIMULTANEOUS',
    SEQUENTIAL_ASCENDING: 'SEQUENTIAL_ASCENDING',
    SEQUENTIAL_DESCENDING: 'SEQUENTIAL_DESCENDING',
    RANDOM: 'RANDOM'
})

export default IntervalPlayingMode;
